// extracted by mini-css-extract-plugin
module.exports = {"iconBox":"Input_iconBox__3LUez","startIconBox":"Input_startIconBox__1V2c9","endIconBox":"Input_endIconBox__1v_4b"};